<template>
  <div class='filtered-search'>
    <div class="filtered-search__filter_chips">
      <v-chip-group
        :show-arrows='true'
      >
        <v-chip v-for="(filter, index) in filtersSearch"
                :key="`${filter}-${index}`"
                close
                color="#657D94"
                text-color="white"
                class="filtered-search__filter_chips__chip"
                @click="deleteFilterSelection(index)"
                @click:close="deleteFilterSelection(index)"
        >
          {{filter}}
        </v-chip>
      </v-chip-group>
    </div>
    <v-menu v-if="showFilters"
            v-model="menu"
            :close-on-content-click="false"
            :max-width="220"
            offset-x
    >
      <template v-slot:activator="{ on }">
        <v-btn class="filtered-search__filter-button" v-on="on" :ripple="false">
          <v-icon :class="!menu? 'material-icons-outlined':'material-icons'">filter_list</v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-list>
          <v-list-item v-for="(filter, index) in filters" :key="index" link @click="chooseFilter(filter)">
            <v-list-item-title class="filtered-search__filter-title">{{filter.name}}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>
    <v-text-field
      v-if="showFilterInput"
      solo
      :append-icon="'add'"
      :prepend-icon="'close'"
      @click:append="addFilter"
      @click:prepend="clearFilterInput"
      @keydown.native.escape="clearFilterInput"
      @keydown.native.enter="addFilter"
      v-model="filterInput"
      class="filtered-search__filter-text-field"
    />
    <v-text-field
      :append-icon="search?'close':'search'"
      @click:append="clearSearch"
      @keydown.native.escape="clearSearch"
      @keydown.native.enter="addSearchOnEnterClick"
      label="Search"
      solo
      v-model="search"
      class="filtered-search__text-field"
      height="30px"
   />
    <select-port-popup
      class='suppress-subdomains-popup'
      :visible-popup="showSelectPortPopup"
      :title="'infrastructure.select.ports.title'"
      :no-caption="'infrastructure.select.ports.no'"
      :yes-caption="'infrastructure.select.ports.yes'"
      @clicked="handleSelectPortPopupClick"
    />
    <select-compliance-popup
      class='suppress-subdomains-popup'
      :visible-popup="showSelectCompliancePopup"
      :title="'infrastructure.select.compliance.title'"
      :no-caption="'infrastructure.select.compliance.no'"
      :yes-caption="'infrastructure.select.compliance.yes'"
      @clicked="handleSelectCompliancePopupClick"
    />
    <select-sensitivity-filter-popup
      class='suppress-subdomains-popup'
      :visible-popup="showSelectSensitivityPopup"
      :title="'infrastructure.select.sensitivity.title'"
      :no-caption="'infrastructure.select.sensitivity.no'"
      :yes-caption="'infrastructure.select.sensitivity.yes'"
      @clicked="handleSelectSensitivityPopupClick"
    />
    <select-c-s-p-filter-popup
      class='suppress-subdomains-popup'
      :visible-popup="showSelectCSPPopup"
      :title="'infrastructure.select.csp.title'"
      :no-caption="'infrastructure.select.csp.no'"
      :yes-caption="'infrastructure.select.csp.yes'"
      @clicked="handleSelectCSPPopupClick"
    />
    <select-w-a-f-filter-popup
      class='suppress-subdomains-popup'
      :visible-popup="showSelectWAFPopup"
      :title="'infrastructure.select.waf.title'"
      :no-caption="'infrastructure.select.waf.no'"
      :yes-caption="'infrastructure.select.waf.yes'"
      @clicked="handleSelectWAFPopupClick"
    />
    <select-services-filter-popup
      class='suppress-subdomains-popup'
      :visible-popup="showSelectServicesPopup"
      :title="'infrastructure.select.services.title'"
      :no-caption="'infrastructure.select.services.no'"
      :yes-caption="'infrastructure.select.services.yes'"
      @clicked="handleSelectServicesPopupClick"
    />
    <select-risk-score-filter-popup
      class='suppress-subdomains-popup'
      :visible-popup="showSelectRiskScorePopup"
      :title="'infrastructure.select.risk.score.title'"
      :no-caption="'infrastructure.select.risk.score.no'"
      :yes-caption="'infrastructure.select.risk.score.yes'"
      @clicked="handleSelectRiskScorePopupClick"
    />
    <select-assets-filter-popup
      class='suppress-subdomains-popup'
      :visible-popup="showSelectAssetsPopup"
      :title="'infrastructure.select.assets.title'"
      :no-caption="'infrastructure.select.assets.no'"
      :yes-caption="'infrastructure.select.assets.yes'"
      @clicked="handleSelectAssetsPopupClick"
    />
    <select-last-scanned-date-filter-popup
      class='suppress-subdomains-popup'
      :visible-popup="showSelectLastScannedDatePopup"
      :title="'infrastructure.select.last.scanned.date.title'"
      :no-caption="'infrastructure.select.last.scanned.date.no'"
      :yes-caption="'infrastructure.select.last.scanned.date.yes'"
      @clicked="handleSelectLastScannedDatePopupClick"
    />
    <select-sensitivity-infrastructure-filter-popup
      class='suppress-subdomains-popup'
      :visible-popup="showSelectSensitivityInfrastructurePopup"
      :title="'infrastructure.select.sensitivity.title'"
      :no-caption="'infrastructure.select.sensitivity.no'"
      :yes-caption="'infrastructure.select.sensitivity.yes'"
      @clicked="handleSelectSensitivityInfrastructurePopupClick"
    />
    <select-leak-date-filter-popup
      class='suppress-subdomains-popup'
      :visible-popup="showSelectLeakDatePopup"
      :title="'employees.select.leak.date.title'"
      :no-caption="'employees.select.leak.date.no'"
      :yes-caption="'employees.select.leak.date.yes'"
      @clicked="handleSelectLeakDatePopupClick"
    />
    <select-credentials-filter-popup
      class='suppress-subdomains-popup'
      :visible-popup="showSelectCredentialsPopup"
      :title="'employees.select.credentials.title'"
      :no-caption="'employees.select.credentials.no'"
      :yes-caption="'employees.select.credentials.yes'"
      @clicked="handleSelectCredentialsPopupClick"
    />
  </div>
</template>
<script>
import SelectPortPopup from '@/components/popup/SelectPortPopup.vue';
import SelectCompliancePopup from '@/components/popup/SelectCompliancePopup.vue';
import { mapGetters } from 'vuex';
import SelectSensitivityFilterPopup from '@/components/popup/SelectSensitivityFilterPopup.vue';
import SelectRiskScoreFilterPopup from '@/components/popup/SelectRiskScoreFilterPopup.vue';
import SelectAssetsFilterPopup from '@/components/popup/SelectAssetsFilterPopup.vue';
import SelectLastScannedDateFilterPopup from '@/components/popup/SelectLastScannedDateFilterPopup.vue';
import SelectCSPFilterPopup from '@/components/popup/SelectCSPFilterPopup.vue';
import SelectWAFFilterPopup from '@/components/popup/SelectWAFFilterPopup.vue';
import SelectServicesFilterPopup from '@/components/popup/SelectServicesFilterPopup.vue';
import SelectSensitivityInfrastructureFilterPopup from '@/components/popup/SelectSensitivityInfrastructureFilterPopup.vue';
import SelectLeakDateFilterPopup from '@/components/popup/SelectLeakDateFilterPopup.vue';
import SelectCredentialsFilterPopup from '@/components/popup/SelectCredentialsFilterPopup.vue';

export default {
  name: 'FilteredSearch',
  props: {
    showFilters: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    filters: {
      type: Array,
      required: false,
      default: () => [],
    },
    filterItems: {
      type: Array,
      required: false,
      default: () => [],
    },
    searchItem: {
      type: String,
      required: false,
      default: () => '',
    },
    tab: {
      type: String,
      required: false,
      default: () => '',
    },
  },
  data() {
    return {
      search: this.searchItem || '',
      filtersSearch: [...this.filterItems] || [],
      menu: false,
      showFilterInput: false,
      filterInput: '',
      showSelectPortPopup: false,
      showSelectCompliancePopup: false,
      showSelectSensitivityPopup: false,
      showSelectSensitivityInfrastructurePopup: false,
      showSelectCSPPopup: false,
      showSelectWAFPopup: false,
      showSelectServicesPopup: false,
      showSelectRiskScorePopup: false,
      showSelectAssetsPopup: false,
      showSelectLastScannedDatePopup: false,
      showSelectLeakDatePopup: false,
      showSelectCredentialsPopup: false,
      date: [new Date(), new Date()],
    };
  },
  components: {
    SelectServicesFilterPopup,
    SelectWAFFilterPopup,
    SelectSensitivityFilterPopup,
    SelectPortPopup,
    SelectCompliancePopup,
    SelectRiskScoreFilterPopup,
    SelectAssetsFilterPopup,
    SelectLastScannedDateFilterPopup,
    SelectCSPFilterPopup,
    SelectSensitivityInfrastructureFilterPopup,
    SelectLeakDateFilterPopup,
    SelectCredentialsFilterPopup,
  },
  computed: {
    ...mapGetters(['domainFilter']),
  },
  methods: {
    clearSearch() {
      this.search = '';
    },
    clearFilterInput() {
      this.filterInput = '';
      this.showFilterInput = false;
    },
    chooseFilter(filter) {
      this.menu = false;
      if (filter.attr === 'selectPort') {
        this.showSelectPortPopup = true;
      } else if (filter.attr === 'selectCompliance') {
        this.showSelectCompliancePopup = true;
      } else if (filter.attr === 'sensitivity' && this.tab !== 'infrastructure') {
        this.showSelectSensitivityPopup = true;
      } else if (filter.attr === 'sensitivity' && this.tab === 'infrastructure') {
        this.showSelectSensitivityInfrastructurePopup = true;
      } else if (filter.attr === 'CSP') {
        this.showSelectCSPPopup = true;
      } else if (filter.attr === 'WAF') {
        this.showSelectWAFPopup = true;
      } else if (filter.attr === 'service') {
        this.showSelectServicesPopup = true;
      } else if (filter.attr === 'riskScore') {
        this.showSelectRiskScorePopup = true;
      } else if (filter.attr === 'assets') {
        this.showSelectAssetsPopup = true;
      } else if (filter.attr === 'lastScannedDate') {
        this.showSelectLastScannedDatePopup = true;
      } else if (filter.attr === 'leakDate') {
        this.showSelectLeakDatePopup = true;
      } else if (filter.attr === 'credentials') {
        this.showSelectCredentialsPopup = true;
      } else {
        this.filterInput = `${filter.attr}: `;
        this.showFilterInput = true;
      }
    },
    deleteFilterSelection(index) {
      this.filtersSearch.splice(index, 1);
    },
    addFilter() {
      if (this.filterInput.split(':')[0] === 'riskScore' || this.filterInput.split(':')[0] === 'assets') {
        this.filterInput = this.filterInput.replace(',', '-');
      }
      let result = this.filterInput.split(':');
      if (this.filterInput.includes('ip:')) {
        result = this.filterInput.split(/:(.*)/s).slice(0, 2);
      }
      if (result.length > 1 && result[1].trim().length > 0) {
        if (!this.filtersSearch.includes(this.filterInput)) {
          this.filtersSearch.push(this.filterInput);
        }
      }
      this.clearFilterInput();
    },
    addSearchOnEnterClick() {
      this.$emit('searchInput', this.search);
    },
    handleSelectPortPopupClick(clickedValue) {
      if (clickedValue) {
        this.filterInput = `port: ${clickedValue.join(',')}`;
        this.addFilter();
      }
      this.showSelectPortPopup = false;
    },
    handleSelectSensitivityPopupClick(clickedValue) {
      if (clickedValue) {
        this.filterInput = `sensitivity: ${clickedValue}`;
        this.addFilter();
      }
      this.showSelectSensitivityPopup = false;
    },
    handleSelectSensitivityInfrastructurePopupClick(clickedValue) {
      if (clickedValue) {
        this.filterInput = `sensitivity: ${clickedValue}`;
        this.addFilter();
      }
      this.showSelectSensitivityInfrastructurePopup = false;
    },
    handleSelectCSPPopupClick(clickedValue) {
      if (clickedValue) {
        this.filterInput = `CSP: ${clickedValue.join(',')}`;
        this.addFilter();
      }
      this.showSelectCSPPopup = false;
    },
    handleSelectWAFPopupClick(clickedValue) {
      if (clickedValue) {
        this.filterInput = `WAF: ${clickedValue.join(',')}`;
        this.addFilter();
      }
      this.showSelectWAFPopup = false;
    },
    handleSelectServicesPopupClick(clickedValue) {
      if (clickedValue) {
        this.filterInput = `service: ${clickedValue.join(',')}`;
        this.addFilter();
      }
      this.showSelectServicesPopup = false;
    },
    handleSelectRiskScorePopupClick(clickedValue) {
      if (clickedValue) {
        this.filterInput = `riskScore: ${clickedValue.join(',')}`;
        this.addFilter();
      }
      this.showSelectRiskScorePopup = false;
    },
    handleSelectAssetsPopupClick(clickedValue) {
      if (clickedValue) {
        this.filterInput = `assets: ${clickedValue.join(',')}`;
        this.addFilter();
      }
      this.showSelectAssetsPopup = false;
    },
    handleSelectLastScannedDatePopupClick(clickedValue) {
      if (clickedValue && (clickedValue.to || clickedValue.from)) {
        if (clickedValue.to && !clickedValue.from) {
          this.filterInput = `lastScannedDate: < ${clickedValue.to}`;
        } else if (!clickedValue.to && clickedValue.from) {
          this.filterInput = `lastScannedDate: > ${clickedValue.from}`;
        } else {
          this.filterInput = `lastScannedDate: ${clickedValue.from} - ${clickedValue.to}`;
        }
        this.addFilter();
      }
      this.showSelectLastScannedDatePopup = false;
    },
    handleSelectCompliancePopupClick(clickedValue) {
      if (clickedValue) {
        this.filterInput = `compliance: ${clickedValue.join(',')}`;
        this.addFilter();
      }
      this.showSelectCompliancePopup = false;
    },
    handleSelectLeakDatePopupClick(clickedValue) {
      if (clickedValue && (clickedValue.to || clickedValue.from)) {
        if (clickedValue.to && !clickedValue.from) {
          this.filterInput = `leakDate: < ${clickedValue.to}`;
        } else if (!clickedValue.to && clickedValue.from) {
          this.filterInput = `leakDate: > ${clickedValue.from}`;
        } else {
          this.filterInput = `leakDate: ${clickedValue.from} - ${clickedValue.to}`;
        }
        this.addFilter();
      }
      this.showSelectLeakDatePopup = false;
    },
    handleSelectCredentialsPopupClick(clickedValue) {
      // One popup produces several chips (the length and each character class),
      // so every selected key is added as its own `key: value` chip.
      if (clickedValue) {
        const attrs = Object.keys(clickedValue);
        // Re-applying replaces the previous chip for the same key instead of
        // stacking a second one — two ranges for the same attribute would
        // otherwise be ANDed server-side and match nothing.
        if (attrs.length) {
          this.filtersSearch = this.filtersSearch.filter(
            existing => !attrs.includes(existing.split(':')[0].trim()),
          );
        }
        attrs.forEach(attr => {
          this.filterInput = `${attr}: ${clickedValue[attr]}`;
          this.addFilter();
        });
      }
      this.showSelectCredentialsPopup = false;
    },
  },
  watch: {
    filterItems: {
      handler() {
        if (this.filterItems?.length) {
          [this.filterInput] = this.filterItems;
          this.addFilter();
        }
      },
      deep: true,
    },
    domainFilter() {
      this.search = '';
      if (this.tab === 'infrastructure') {
        this.filtersSearch = [];
      }
    },
    search() {
      if (this.search === '') {
        this.$emit('searchInput', this.search);
      }
    },
    filtersSearch() {
      this.$emit('filtersInput', this.filtersSearch);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.filtered-search {
  display: flex;
  flex-direction: row;
  align-items: center;
  border: 1px solid var(--border-primary);
  background-color: var(--bg-primary);
  height: rem(48);
  margin-top: $space-2;
  max-width: rem(1080);
  width: auto;

  &__filter_chips {
    margin-left: $space-1;
    max-width: rem(400);

    &__chip {
      margin-right: $space-1;

      .v-chip .v-chip__close.v-icon {
        font-size: rem(22);
      }
    }
  }

  &__filter-title {
    font-family: $font-family-regular;
    font-size: $font-size-sm;
    white-space: nowrap;
  }

  &__text-field {
  }

  &__filter-text-field {
    max-width: rem(250);
  }

  &__filter-button {
    background-color: transparent !important;
    text-align: center;
    box-shadow: none;
    min-width: rem(40);
    max-width: rem(40);
    min-height: rem(40);
    max-height: rem(40);
    margin-top: 0;
    user-select: none;
    color: var(--text-secondary);

    .v-icon {
      font-size: rem(28);
    }

    &:hover {
      cursor: pointer;
      color: var(--brand-primary);

      .v-icon {
        color: var(--brand-primary) !important;
      }
    }

    &:before {
      color: transparent;
      background-color: transparent;
    }
  }
}
</style>

<style lang="scss">
@import '~@/assets/styles/design-system';

.filtered-search {
  .v-text-field {
    margin-top: rem(7) !important;
  }

  .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
    box-shadow: none;
    border: none;
    border-radius: $radius-sm;
    max-height: rem(30);
    background-color: var(--bg-primary) !important;
  }

  .v-input__icon.v-input__icon--append button {
    font-size: rem(24) !important;
    color: var(--text-secondary) !important;
  }

  // Purple icon when field is focused (magnifying glass) or has value (close icon)
  .filtered-search__text-field.v-input--is-focused .v-input__icon.v-input__icon--append .v-icon,
  .filtered-search__text-field.v-input--is-dirty .v-input__icon.v-input__icon--append .v-icon {
    color: var(--brand-primary) !important;
  }

  .v-text-field.v-text-field--solo .v-input__control {
    min-height: rem(30);
  }

  .v-chip .v-chip__close.v-icon {
    font-size: rem(22) !important;
  }

  &__filter-text-field {
    .v-input__prepend-outer {
      margin-right: rem(2);
      margin-top: $space-1 !important;

      .v-icon {
        color: var(--text-secondary) !important;
      }
    }

    .v-input__append-inner {
      margin-top: 0 !important;
    }
  }

  .v-slide-group__wrapper {
    padding-left: 0;
    background-color: var(--bg-primary);
    height: rem(40);
    margin-top: rem(-7);
  }

  .v-slide-group__next,
  .v-slide-group__prev {
    flex: 0 1 rem(20);
    min-width: rem(20);
  }

  .v-label {
    color: var(--text-secondary) !important;
  }

  .v-icon {
    color: var(--text-secondary) !important;
  }

  .v-input__icon.v-input__icon--append .v-icon {
    color: var(--text-secondary) !important;
  }
}
</style>
